import { Injectable } from '@angular/core';
import { HisAmountPipe } from 'hisng';

@Injectable()
export class AmountUtils {

    constructor( private readonly hisAmountPipe: HisAmountPipe ) { }

    /**
     * get formatted amount for generic amount types
     */
    getFormattedAmount( amount: number ) {
        if ( amount == null ) {
            return this.hisAmountPipe.transform( 0 );
        } else {
            if ( isNaN( amount ) === false ) {
                return this.hisAmountPipe.transform( amount );
            } else {
                return amount;
            }
        }
    }
}
